import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import kuganSir from "../image/kugansir.png";
import PhysicsSir from "../image/back.jpg";
import chemistrtsir from "../image/chemistry_sir.png";
import banner2 from "../image/banph.png";
import video from "../image/video.mp4";
import timetable2 from "../image/time table.jpg";
import timetable1 from "../image/phytimetable.jpg";

import banner1 from "../image/bannernew.jpg";
import banner5 from "../image/bannernew1.jpg";
import banner3 from "../image/phnew1.jpg";
import banner4 from "../image/chem1.png";
import banner6 from "../image/phnew11.jpg";
import banner7 from "../image/chem2.png";
import banner8 from "../image/phnew9.jpg";
import banner9 from "../image/add.jpeg";
import banner10 from "../image/phnew7.jpg";
import banner11 from "../image/phnew5.jpg";
import banner12 from "../image/chem1.png";
import banner13 from "../image/chem3.jpeg";
import banner14 from "../image/kugansir1.jpeg";
import timetable from "../image/timetable.png";

const HomePage = () => {
  const [selectedImg, setSelectedImg] = useState(null); // state for popup

  useEffect(() => {
    const NUM_BALLS = 18;
    const balls = [];
    const colors = [
      "#f1f5ff", // very light blue
      "#a5b4fc", // soft indigo
      "#fcd34d", // soft yellow
      "#fca5a5", // soft red
      "#6ee7b7", // soft green
      "#f9a8d4", // soft pink
      "#c7d2fe", // blue-gray
      "#fff"
    ];
    const container = document.getElementById("randomBallsBg");
    if (!container) return;
    container.innerHTML = "";
    const footer = document.querySelector("footer");
    let footerHeight = 0;
    if (footer) {
      footerHeight = footer.offsetHeight;
    }
    const W = window.innerWidth;
    const H = window.innerHeight - footerHeight;
    for (let i = 0; i < NUM_BALLS; i++) {
      const ball = document.createElement("div");
      const size = Math.random() * 18 + 12;
      ball.className = "random-ball";
      ball.style.width = `${size}px`;
      ball.style.height = `${size}px`;
      ball.style.background = colors[Math.floor(Math.random() * colors.length)];
      ball.style.left = `${Math.random() * (W - size)}px`;
      ball.style.top = `${Math.random() * (H - size)}px`;
      container.appendChild(ball);
      balls.push({
        el: ball,
        x: parseFloat(ball.style.left),
        y: parseFloat(ball.style.top),
        dx: (Math.random() - 0.5) * 1.5,
        dy: (Math.random() - 0.5) * 1.5,
        size,
      });
    }
    let running = true;
    function animate() {
      if (!running) return;
      for (const b of balls) {
        b.x += b.dx;
        b.y += b.dy;
        if (b.x < 0 || b.x > W - b.size) b.dx *= -1;
        if (b.y < 0 || b.y > H - b.size) b.dy *= -1;
        b.x = Math.max(0, Math.min(W - b.size, b.x));
        b.y = Math.max(0, Math.min(H - b.size, b.y));
        b.el.style.transform = `translate(${b.x}px, ${b.y}px)`;
      }
      requestAnimationFrame(animate);
    }
    animate();
    return () => {
      running = false;
      if (container) container.innerHTML = "";
    };
  }, []);

  const images = [
    banner1, banner2, banner3, banner4, banner5, banner6,
    banner7, banner8, banner9, banner10, banner11, banner12,
    banner13, banner14, timetable
  ];
  return (
    <div className="relative bg-lightblue text-primary px-2 md:px-0 overflow-hidden min-h-screen flex justify-center items-start">
      {/* Animated Random Balls Background */}
      <div className="random-balls-bg" id="randomBallsBg"></div>
      {/* Content */}
      <div className="relative z-10 w-full max-w-[90vw] mx-auto">
                <section className="py-8 text-center w-full flex flex-col items-center">
          <h2 className="text-4xl md:text-6xl font-extrabold animate-pulse uppercase">Admissions for 2028 G.C.E A/L Open!</h2>
          <p className="mt-2 text-2xl md:text-3xl font-semibold text-black">Enroll now for the best learning experience.</p>
          <Link
            to="/admissions"
            className="mt-6 bg-primary text-white text-2xl md:text-3xl px-12 py-4 rounded-lg hover:bg-blue-700 transition duration-300"
          >
            Enroll Now
          </Link>
        </section>
      <section className="w-full flex items-center justify-center relative mt-6">
  <Swiper
    modules={[Navigation, Pagination, Autoplay]}
    navigation
    pagination={{ clickable: true }}
    autoplay={{ delay: 5000, disableOnInteraction: false }}
    className="w-full h-full"
  >
    <SwiperSlide>
      <video
        autoPlay
        loop
        muted
        playsInline
        className="w-full h-auto max-h-[80vh] rounded-lg shadow-lg object-contain"
        style={{ display: 'block', margin: '0 auto' }}
      >
        <source src={video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </SwiperSlide>
  </Swiper>
</section>



        <section className="py-8 text-center max-w-5xl mx-auto col">
  <h2 className="text-4xl font-bold mb-6">Our Teachers</h2>
  <div className="flex flex-wrap justify-center gap-8 mt-2">
    {[
      { name: "M.Kugan", degree: "BSc (Hons), Dip in Edu", img: kuganSir, subject: "Physics Sir" },
      { name: "T.Sharangan", degree: "BSc [UG]", img: chemistrtsir, subject: "Chemistry Sir" },
      { name: "T.Manimohan", degree: "BSc Eng (Hons) in Electronic and Telecommunication Engineering", img: PhysicsSir, subject: "Physics Sir" }
    ].map((teacher, index) => (
      <div
        key={index}
        className="w-72 bg-blue-100/50 backdrop-blur-md shadow-xl rounded-2xl text-black p-6 flex flex-col items-center transform transition-transform duration-300 hover:scale-105"
      >
        <div className="w-36 h-36 rounded-full overflow-hidden border-4 border-blue-500 shadow-md mb-4">
          <img
            src={teacher.img}
            alt={teacher.name}
            className="w-full h-full object-cover"
          />
        </div>
        <h3 className="text-lg font-semibold text-blue-800">{teacher.subject}</h3>
        <h3 className="text-xl font-bold mt-2">{teacher.name}</h3>
        <p className="text-sm text-gray-700">{teacher.degree}</p>
      </div>
    ))}
  </div>
</section>



        {/* Classes Section */}
        <section className="py-8 text-center max-w-6xl mx-auto">
          <h2 className="text-4xl font-bold mb-6">Our Classes</h2>
          <div className="flex justify-center gap-6 mt-6 flex-wrap">
            {[timetable1, timetable2].map((img, index) => (
              <img
                key={index}
                src={img}
                alt="Class Timetable"
                className="w-full max-w-md rounded-lg shadow-md object-cover mb-6"
              />
            ))}
          </div>
          <Link to="/timetable" className="text-bold text-2xl md:text-3xl">
            Click for more...
          </Link>
        </section>
          <section className="w-full py-8 overflow-hidden relative">
          <div className="flex w-max animate-marquee">
            {images.concat(images).map((img, index) => (
              <div
                key={index}
                className="flex-shrink-0 px-4 cursor-pointer"
                onClick={() => setSelectedImg(img)}
              >
                <img
                  src={img}
                  alt={`Banner Slide ${index + 1}`}
                  className="h-40 w-auto object-cover rounded-lg shadow-lg"
                />
              </div>
            ))}
          </div>
        </section>

        {/* Popup Modal */}
        {selectedImg && (
          <div
            className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
            onClick={() => setSelectedImg(null)}
          >
            <img
              src={selectedImg}
              alt="Selected Banner"
              className="max-h-[90%] max-w-[90%] rounded-xl shadow-2xl"
            />
          </div>
        )}


<section className="py-8 text-center w-full">
  <h2 className="text-4xl font-bold mb-4">Our Location</h2>
  <div className="relative w-full h-[200px] mx-auto">
    <iframe
      className="w-full h-full"
      src="https://maps.google.com/maps?q=P2XH+PR%20Chunnakam%20LAUGFS%20ECO%20SRI%20-%20Chunnakam%20Vehicle%20Emission%20Testing%20Center&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed"
      frameBorder="0"
      scrolling="no"
      allowFullScreen
      title="Universal Science Academy Location Map"
    ></iframe>
  </div>
</section>


      </div>
    </div>
  );
};


export default HomePage;
